import { useState, useEffect } from 'react';

const navItems = [
  { label: '首页', href: '#hero' },
  { label: '热门话题', href: '#topics' },
  { label: '热度榜单', href: '#ranking' },
  { label: '移动端体验', href: '#app' },
  { label: '联系我们', href: '#contact' },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setMobileOpen(false);
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <a
            href="#hero"
            onClick={(e) => handleNavClick(e, '#hero')}
            className="flex items-center gap-2 shrink-0"
          >
            <div className="w-8 h-8 md:w-9 md:h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-movie-2-line text-lg md:text-xl"></i>
            </div>
            <span className={`text-lg md:text-xl font-heading whitespace-nowrap transition-colors duration-300 ${scrolled ? 'text-foreground-900' : 'text-background-50'}`}>
              牛牛影视
            </span>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`px-4 py-2 text-sm font-medium rounded-full whitespace-nowrap cursor-pointer transition-all duration-200 ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-background-50/90 hover:text-background-50 hover:bg-white/10'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-9 h-9 flex items-center justify-center rounded-lg cursor-pointer transition-colors ${
              scrolled ? 'text-foreground-700 hover:bg-background-100' : 'text-background-50 hover:bg-white/10'
            }`}
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>

        {mobileOpen && (
          <div className="md:hidden pb-4 border-t border-background-200/40 mt-1 pt-3">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="block px-4 py-3 text-sm font-medium text-foreground-700 hover:text-primary-600 hover:bg-primary-50/50 rounded-lg cursor-pointer transition-colors"
              >
                {item.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </header>
  );
}